import { memo } from 'react';
import clsx from 'clsx';
import { SearchEmpty } from '@alf/uikit';
import { useOtherSettings } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import GamesList from '../../common/GamesList';
import { IS_USE_PLEX_API, ROWS_WITH_GAMES } from '../../constants';
import { useExcludedActiveBonusGamesList } from '../../store';
import { gamesPlaceholder } from '../../utils';

import styles from './index.module.css';

export const SearchResultGames = memo(
  ({
    games,
    isFeedLoaded,
    config,
    casinoType,
    controls,
    gamesListId,
    onGameClick,
    page,
    onChangePage,
    classNames = {},
    isPlexAllGamesLoaded,
    isPlexLoading
  }) => {
    const { t } = useI18n();
    const { excludedBonusGamesList } = useExcludedActiveBonusGamesList();
    const { isGameCardsMinimisedConfig = false } = useOtherSettings();
    const { isDesktop } = useDeviceStore();

    if (games?.length || !isFeedLoaded) {
      return (
        <div
          className={clsx([
            styles.resultsWrapper,
            isGameCardsMinimisedConfig &&
              !isDesktop &&
              styles.resultsWrapperMinimised
          ])}
        >
          <GamesList
            key={gamesListId}
            casinoType={casinoType}
            games={!isFeedLoaded ? gamesPlaceholder : games}
            config={config}
            excludedBonusGamesList={excludedBonusGamesList}
            controls={controls}
            {...(IS_USE_PLEX_API
              ? {
                  isPlexAllGamesLoaded,
                  isPlexLoading,
                  kind: ROWS_WITH_GAMES.ALL_WITH_PLEX_PAGINATION
                }
              : {
                  kind: ROWS_WITH_GAMES.ALL
                })}
            onGameClick={onGameClick}
            page={page}
            sectionName="casino_search"
            onChangePage={onChangePage}
            classNames={{ ...classNames }}
            {...(gamesListId ? { id: gamesListId } : {})}
          />
        </div>
      );
    }

    return (
      !!games && (
        <>
          <SearchEmpty
            classNames={{
              text: styles.searchEmptyText,
              infoText: styles.searchEmptyInfoText
            }}
            text={t('casinoGames.notFound')}
            infoText={t('web.games.search.sorry')}
          />
        </>
      )
    );
  }
);
